import React from 'react';

import { SuccessIcon } from '@lt/components';
import { ButtonWithLoader } from 'src/components/AuthNew/components/ButtonWithLoader/ButtonWithLoader';
import styles from './emailOrPasswordConfirmationForm.module.css';
import { Title } from '../Title';
import { Content } from '../Content';
import { ActionItem } from '../ActionItem';
import { ConfirmedData } from '../../types';

interface Props {
  onClose?: () => void;
  backToLoginForm: () => void;
  isLoggedIn?: boolean;
  confirmedData: ConfirmedData;
  isMobile?: boolean;
}

export const EmailOrPasswordConfirmationForm: React.FC<Props> = ({
  onClose,
  backToLoginForm,
  isLoggedIn,
  confirmedData,
  isMobile,
}) => (
  <>
    <Title className={styles.title}>
      {confirmedData === ConfirmedData.Password
        ? 'Пароль успешно установлен'
        : 'Ваша почта успешно подтверждена'}
    </Title>
    <SuccessIcon className={styles.successIcon} success />
    <Content className={styles.content}>
      {!isLoggedIn && !isMobile && (
        <ButtonWithLoader onClick={backToLoginForm} primary width="100%">
          Войти
        </ButtonWithLoader>
      )}
      {isLoggedIn && (
        <ActionItem className={styles.actionItem} onClick={onClose}>
          На главную
        </ActionItem>
      )}
    </Content>
  </>
);
